export const REQUEST_HEADER_KEYS = {
	xImpersonated: 'X-Impersonated',
};

export const RESPONSE_HEADER_KEYS = {
	contentDisposition: 'content-disposition',
	contentLength: 'content-length',
	contentType: 'content-type',
	eTag: 'etag',
	xImpersonated: 'x-impersonated',
};

/**
 * Extracts the relevant headers from Axios response
 * @param {import('axios').AxiosResponseHeaders | import('axios').RawAxiosResponseHeaders | undefined} headers
 * @returns {{ contentDisposition: string | null, contentLength: string | null, contentType: string | null, eTag: string | null }}
 */
export function extractRelevantHeaders(headers) {
	if (!headers) {
		return {
			contentDisposition: null,
			contentLength: null,
			contentType: null,
			eTag: null,
			xImpersonated: null,
		};
	}

	// Axios returns headers in lowercase by default
	return {
		contentDisposition:
			headers[RESPONSE_HEADER_KEYS.contentDisposition] ?? null,
		contentLength: headers[RESPONSE_HEADER_KEYS.contentLength] ?? null,
		contentType: headers[RESPONSE_HEADER_KEYS.contentType] ?? null,
		eTag: headers[RESPONSE_HEADER_KEYS.eTag] ?? null,
		xImpersonated: headers[RESPONSE_HEADER_KEYS.xImpersonated] ?? null,
	};
}
